define('constant/myreport/report-all.constant',[], function () {
    return {
        payType: {
            1: "华为钱包", 2: "充值卡", 3: "游戏卡", 4: "信用卡", 5: "支付宝", 6: "短代",
            10: "财付通", 11: "神州付", 12: "天翼", 13: "PayPal", 14: "移动话费",
            15: "联通话费", 16: "借记卡", 17: "微信", 18: "花瓣", 30: "银视通"
        },
        payType_Old: {
            0: "华为钱包", 1: "充值卡", 2: "游戏卡",
            3: "信用卡", 4: "支付宝", 5: "--", 6: "短代", 7: "非银行卡",
            8: "非银行卡余额", 9: "组合支付", 10: "财付通", 11: "神州付", 12: "天翼",
            13: "PayPal", 15: "联通话费", 16: "借记卡", 17: "微信", 18: "花瓣",
            19: "礼品卡", 20: "现金余额", 21: "华为充值卡", 22: "CyberSource", 30: "银视通",
            50: "预付款", 52: "M2E", 53: "FPX", 54: "FPXE", 55: "融资",
            56: "GlobalPay", 57: "分期", 58: "MP", 59: "MOLPAY", 100: "CUSTPAY1-100"
        },
        tradeStatus: {
            0: "已付", 1: "已退", 2: "付款失败", 3: "退款失败", 4: "未支付", 5: "退款中"
        },
        settleReturnDesc: {
            'download_paymentOrder': {
                '1': '参数错误',
                '2': '签名未通过',
                '5': '暂无相关数据。',
                '900003' : '暂无相关数据'
            },
            'query_paymentOrder': {
                '1': '参数错误',
                '2': '签名未通过'
            },
            'sign': {
                '1': '参数错误'
            },
            'notifytrigger': {
                '1': '参数错误',
                '2': '签名未通过'
            },
            'tradeRefund': {
                '1': '参数错误',
                '2': '签名未通过'
            },
            'pay_payoff_queryV1': {
                '1': '参数错误',
                '2': '签名未通过',
                '3': '参数类型异常'
            },
            'applySettle': {
                '10001': '传递参数解析失败',
                '1': '参数错误',
                '2': '签名未通过',
                '3': '用户不能申请结算',
                '10002': '账单重复申请'
            },
            'download_bill_comfirm': {
                '1': '参数错误',
                '2': '签名未通过',
                '3': '当前操作遇到异常无法正常完成，请联系运营处理',
                '5': '无结算请求'
            }
        },
        payTypeCons: {
            'YeePayCharge': '充值卡',
            'YeePayGame': '游戏卡',
            'HuaWeiPay': '花币',
            'YeePayBank': '信用卡',
            'AliPay': '支付宝',
            'smsAgent': '短代',
            '短代': '短代',
            'YeePaynonBank': '非银行卡',
            'BalanceofnonBank': '非银行卡余额',
            'YeePayMixed': '组合支付',
            'IncomeAdjust': '收入调整',
            'SpendingAdjust': '支出调整',
            'TenPay': '财付通',
            'SZF': '神州付',
            'BestPay': '天翼',
            'PayPal': 'PayPal',
            'MobPay': '移动话费',
            'UniPay': '联通话费',
            'DebitCard': '借记卡',
            'WX': '微信',
            'Petal': '花瓣',
            'CnTVPay': '银视通',
            'AdvPayment': '预付款',
            'BOC': '中行',
            'M2E': 'M2E',
            'FPX': 'FPX',
            'FPXE': 'FPXE',
            'RZ': '融资',
            'GlobalPay': 'GlobalPay',
            'FQ': '分期',
            'callfee ': '话费支付',
            'callfee-cmcc': '中国移动',
            'callfee-cucc': '中国联通',
            'callfee-ctcc': '中国电信'
        },
        sdkChannelCons: {
            '0': '自有应用',
            '1': '智汇云',
            '2': '预装',
            '3': '游戏吧'
        },
        tradeStateCons: {
            '0': '已付',
            '1': '已退',
            '2': '付款失败',
            '3': '退款失败',
            '4': '未支付',
            '5': '退款中'
        },
        notifiedCons: {
            '-1': '等待通知CP',
            '0': '成功',
            '1': '验签失败',
            '2': '超时',
            '3': '业务信息错误',
            '4': 'IP放通名单限制，cp侧拒绝服务',
            '5': 'CP侧订单过期或者已经取消',
            '94': '回调CP结果异常',
            '95': 'IO错误',
            '96': '错误的url',
            '97': '错误的响应',
            '98': '参数错误',
            '99': '其他错误'
        },
        tradeStatusMarketCons : [{id:-1,name:'全部状态'},{id:0,name:'已付'},{id:1,name:'已退'}],
        tradeSDKCons : [{id:-1,name:'全部推广渠道'},{id:0,name:'华为应用'},{id:1,name:'华为应用市场渠道'},{id:2,name:'预装渠道'},{id:3,name:'游戏吧'}],
        tradeSDKQueryTypeCons : [{id:'pay.oprateData.queryBydate',name:'日期'},{id:'pay.oprateData.queryByapp',name:'应用'},{id:'pay.oprateData.queryBytype',name:'支付方式'}],
        tradeStatusGameTicketCons : [{id:'-1',name:'全部状态'},{id:'1',name:'预扣'},{id:'2',name:'确认扣除'},{id:'3',name:'预扣解除'},{id:'4',name:'直接扣除成功'},{id:'5',name:'直接扣除失败'},{id:'6',name:'退款成功'}],
        preSettlementStatusCons:[{id:'-1',name:'全部'},{id:'0',name:'待确认'},{id:'1',name:'已确认'}],
        preSettlementSettleTypeCons:[{id:'ALL',name:'全部'},{id:'CPP',name:'CPP'},{id:'CPA',name:'CPA'}],
        tradeStatusPaymentCons: [{id: -1, name: '全部状态'}, {id: '0', name: '已付'}, {id: '1', name: '已退'}, {id: '2', name: '付款失败'}, {id: '3', name: '退款失败'}, {id: '4', name: '未支付'}, {id: '5', name: '退款中'}],
        serviceTypePaymentCons: [{id: -1, name: '全部订单类型'}, {id: 'PURCHASE', name: '支付'}, {id: 'REFUND', name: '退款'}],
        payTypePaymentCons: [{id: -1, name: '全部支付方式'}, {id: '充值卡', name: '充值卡'}, {id: '游戏卡', name: '游戏卡'}, {id: '花币', name: '花币'}, {id: '信用卡', name: '信用卡'}, {id: 'AliPay', name: '支付宝'}, {id: '短代', name: '短代'}, {id: '非银行卡', name: '非银行卡'}, {id: '非银行卡余额', name: '非银行卡余额'}, {id: '组合支付', name: '组合支付'}, {id: '收入调整', name: '收入调整'}, {id: '支出调整', name: '支出调整'}, {id: '财付通', name: '财付通'}, {id: 'SZF', name: '神州付'}, {id: '天翼', name: '天翼'}, {id: 'PayPal', name: 'PayPal'}, {id: '移动话费', name: '移动话费'}, {id: '联通话费', name: '联通话费'}, {id: '借记卡', name: '借记卡'}, {id: '微信', name: '微信'}, {id: '花瓣', name: '花瓣'}, {id: '银视通', name: '银视通'}, {id: '预付款', name: '预付款'}, {id: 'BOC', name: '中行'}, {id: 'M2E', name: 'M2E'}, {id: 'FPX', name: 'FPX'}, {id: 'FPXE', name: 'FPXE'}, {id: '融资', name: '融资'}, {id: 'GlobalPay', name: 'GlobalPay'}, {id: '分期', name: '分期'}, {id: 'callfee ', name: '话费支付'}, {id: 'callfee-cmcc', name: '中国移动'}, {id: 'callfee-cucc', name: '中国联通'}, {id: 'callfee-ctcc', name: '中国电信'}],
        sdkChannelPaymentCons: [{id: -1, name: '全部推广渠道'}, {id: '0', name: '自有应用'}, {id: '1', name: '智汇云'}, {id: '2', name: '预装'}, {id: '3', name: '游戏吧'},
            { simple: 'CN', countryName: '中国'}],
        countryCodeList: [
            'DE','IE','ES','FR','IT','FI','SE','PL','EE','BE','AT','CH','RO','LV','HU',
            'SK','NL','CZ','DK','GR','GB','LT','NO','PT','RS','TR','UA','SI','BY','BG',
            'HR','MK','BA','GE','MT','LI','RU','IL','CY','AM','LU','IS','MD','ME','AZ',
            'MC','AD','SM','VA','FO','GI','GL','AL','CN','MY','VN','PH','SG','HK','ID',
            'LK','NP','BD','TH','KH','AU','PG','LA','NZ','JP','MN','MO','BN','FJ','PF',
            'MV','TW','MM','SB','TO','CK','NR','IN','UZ','KZ','KG','TM','TJ','SA','AE',
            'JO','BH','QA','YE','CD','EG','LB','DZ','PK','PS','CM','SN','CG','GN','GA',
            'MR','NE','TD','GQ','CI','BF','ML','LY','BJ','TG','CV','CF','GM','GW','TN',
            'ET','DJ','ER','KW','OM','MA','IQ','ZA','NG','TZ','BW','ZM','MU','UG','GH',
            'ZW','AO','NA','MZ','MG','MW','KE','RE','KM','LR','ST','YT','SZ','LS','SL',
            'RW','CO','PE','MX','AR','BO','EC','UY','PY','JM','TT','CR','CL','GT','HN',
            'NI','DO','BS','AW','VG','LC','GF','KY','PA','VE','SV','BR','GP','PR','GD',
            'AI','GY','HT','CA'
        ],
        country :{
            'CN': '中国',
            'AT': '奥地利',
            'AR': '阿根廷',
            'BD': '孟加拉国',
            'BE': '比利时',
            'BH': '巴林',
            'CH': '瑞士',
            'CL': '智利',
            'CO': '哥伦比亚',
            'CR': '哥斯达黎加',
            'CZ': '捷克',
            'DE': '德国',
            'DK': '丹麦',
            'DZ': '阿尔及利亚',
            'EE': '爱沙尼亚',
            'EG': '埃及',
            'FI': '芬兰',
            'FR': '法国',
            'GE': '格鲁吉亚',
            'GH': '加纳',
            'GR': '希腊',
            'HU': '匈牙利',
            'HK': '中国（香港）',
            'ID': '印度尼西亚',
            'IE': '爱尔兰',
            'IN': '印度',
            'IT': '意大利',
            'JO': '约旦',
            'KE': '肯尼亚',
            'LT': '立陶宛',
            'LV': '拉脱维亚',
            'LK': '斯里兰卡',
            'MY': '马来西亚',
            'MM': '缅甸',
            'MX': '墨西哥',
            'NG': '尼日利亚',
            'NO': '挪威',
            'NP': '尼泊尔',
            'NL': '荷兰',
            'OM': '阿曼',
            'PE': '秘鲁',
            'PK': '巴基斯坦',
            'PH': '菲律宾',
            'PY': '巴拉圭',
            'PL': '波兰',
            'PT': '葡萄牙',
            'QA': '卡塔尔',
            'SA': '沙特阿拉伯',
            'SG': '新加坡',
            'ZA': '南非',
            'SE': '瑞典',
            'SK': '斯洛伐克',
            'RS': '塞尔维亚 ',
            'SI': '斯洛文尼亚 ',
            'ES': '西班牙',
            'RO': '罗马尼亚',
            'TH': '泰国',
            'TN': '突尼斯',
            'TR': '土耳其',
            'TZ': '坦桑尼亚',
            'AE': '阿联酋',
            'GB': '英国',
            'UA': '乌克兰',
            'UZ': '乌兹别克斯坦',
            'UG': '乌干达',
            'VN': '越南'
},

        countryPaymentCons:[
            { simple: 'CN', countryName: '中国'},
            { simple: 'AT', countryName: '奥地利'},
            { simple: 'AR', countryName: '阿根廷'},
            { simple: 'BD', countryName: '孟加拉国'},
            { simple: 'BE', countryName: '比利时'},
            { simple: 'BH', countryName: '巴林'},
            { simple: 'CH', countryName: '瑞士'},
            { simple: 'CL', countryName: '智利'},
            { simple: 'CO', countryName: '哥伦比亚'},
            { simple: 'CR', countryName: '哥斯达黎加'},
            { simple: 'CZ', countryName: '捷克'},
            { simple: 'DE', countryName: '德国'},
            { simple: 'DK', countryName: '丹麦'},
            { simple: 'DZ', countryName: '阿尔及利亚'},
            { simple: 'EE', countryName: '爱沙尼亚'},
            { simple: 'EG', countryName: '埃及'},
            { simple: 'FI', countryName: '芬兰'},
            { simple: 'FR', countryName: '法国'},
            { simple: 'GE', countryName: '格鲁吉亚'},
            { simple: 'GH', countryName: '加纳'},
            { simple: 'GR', countryName: '希腊'},
            { simple: 'HU', countryName: '匈牙利'},
            { simple: 'HK', countryName: '中国（香港）'},
            { simple: 'ID', countryName: '印度尼西亚'},
            { simple: 'IE', countryName: '爱尔兰'},
            { simple: 'IN', countryName: '印度'},
            { simple: 'IT', countryName: '意大利'},
            { simple: 'JO', countryName: '约旦'},
            { simple: 'KE', countryName: '肯尼亚'},
            { simple: 'LT', countryName: '立陶宛'},
            { simple: 'LV', countryName: '拉脱维亚'},
            { simple: 'LK', countryName: '斯里兰卡'},
            { simple: 'MY', countryName: '马来西亚'},
            { simple: 'MM', countryName: '缅甸'},
            { simple: 'MX', countryName: '墨西哥'},
            { simple: 'NG', countryName: '尼日利亚'},
            { simple: 'NO', countryName: '挪威'},
            { simple: 'NP', countryName: '尼泊尔'},
            { simple: 'NL', countryName: '荷兰'},
            { simple: 'OM', countryName: '阿曼'},
            { simple: 'PE', countryName: '秘鲁'},
            { simple: 'PK', countryName: '巴基斯坦'},
            { simple: 'PH', countryName: '菲律宾'},
            { simple: 'PY', countryName: '巴拉圭'},
            { simple: 'PL', countryName: '波兰'},
            { simple: 'PT', countryName: '葡萄牙'},
            { simple: 'QA', countryName: '卡塔尔'},
            { simple: 'SA', countryName: '沙特阿拉伯'},
            { simple: 'SG', countryName: '新加坡'},
            { simple: 'ZA', countryName: '南非'},
            { simple: 'SE', countryName: '瑞典'},
            { simple: 'SK', countryName: '斯洛伐克'},
            { simple: 'RS', countryName: '塞尔维亚 '},
            { simple: 'SI', countryName: '斯洛文尼亚 '},
            { simple: 'ES', countryName: '西班牙'},
            { simple: 'RO', countryName: '罗马尼亚'},
            { simple: 'TH', countryName: '泰国'},
            { simple: 'TN', countryName: '突尼斯'},
            { simple: 'TR', countryName: '土耳其'},
            { simple: 'TZ', countryName: '坦桑尼亚'},
            { simple: 'AE', countryName: '阿联酋'},
            { simple: 'GB', countryName: '英国'},
            { simple: 'UA', countryName: '乌克兰'},
            { simple: 'UZ', countryName: '乌兹别克斯坦'},
            { simple: 'UG', countryName: '乌干达'},
            { simple: 'VN', countryName: '越南'}
        ]
    }
});
